import React from 'react'
import styles from './crossProductTable.module.css';

const SortCrossRefer = ({productlength}) => {
    return (
        <div className={styles.sortedFilter}>
            <div>Showing {productlength} Products</div>
            {/* <div className={styles.loginInputGroup}>
                <div>
                    <select
                        name="state"
                        className={styles.selectField}
                        defaultValue=""
                    >
                        <option value="" disabled hidden c>Sort by</option>
                        <option value="State 1">State 1</option>
                        <option value="State 2">State 2</option>
                    </select>
                    <div className={styles.selectArrowIcon}>
                        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L7 7L13 1" stroke="#9F9F9F" />
                        </svg>
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default SortCrossRefer
